{
  "czlowiek-m": "characters/czlowiek-m-ubc.glb",
  "czlowiek-k": "characters/czlowiek-k-ubc.glb",
  "krasnolud-m": "characters/krasnolud-m-ubc.glb",
  "krasnolud-k": "characters/krasnolud-k-ubc.glb",
  "ork-m": "characters/ork-m-ubc.glb",
  "ork-k": "characters/ork-k-ubc.glb",
  "elf-m": "characters/elf-m-ubc.glb",
  "elf-k": "characters/elf-k-ubc.glb",
  "nieumarly-m": "characters/nieumarly-m-ubc.glb",
  "nieumarly-k": "characters/nieumarly-k-ubc.glb",
  "troll-m": "characters/troll-m-ubc.glb",
  "troll-k": "characters/troll-k-ubc.glb"
}
